module.exports = __webpack_public_path__ + "cc897ced9d4ae0002b52e604699ea384.pdf";